// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface LocationFinder {
    locationSearchText: string;
    searchRadius?: number;
    doesSalesRepExist?: boolean;
    isDealerLoading?: boolean;
}

const initialHeaderState: LocationFinder = {
    searchRadius: 0,
    locationSearchText: "",
    doesSalesRepExist: false,
    isDealerLoading: false,
};

const reducer = {
    "xLocationFinder/updateLocationFinderSearchField": (
        draft: Draft<LocationFinder>,
        action: {
            locationSearchText: string;
            searchRadius?: number;
        },
    ) => {
        typeof action.locationSearchText === "string" && (draft.locationSearchText = action.locationSearchText);
    },
    "xLocationFinder/updateSalesRepExist": (
        draft: Draft<LocationFinder>,
        action: {
            doesSalesRepExist: boolean;
        },
    ) => {
        draft.doesSalesRepExist = action.doesSalesRepExist;
    },
    "xLocationFinder/isDealerLoading": (
        draft: Draft<LocationFinder>,
        action: {
            isDealerLoading: boolean;
        },
    ) => {
        draft.isDealerLoading = action.isDealerLoading;
    },
};

const xLocationFinder = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).xLocationFinder = xLocationFinder;

export type xLocationFinderState = {
    xLocationFinder: LocationFinder;
};

type xLocationFinderReducers = {
    locationSearchText: typeof xLocationFinder;
    searchRadius: typeof xLocationFinder;
};

export type xLocationFinderActions = Parameters<xLocationFinderReducers[keyof xLocationFinderReducers]>[1] | AnyAction;
